import styled from 'styled-components';
import { Steps } from '@brokerbay/design-components';
import { Button, Tabs, Text, theme } from 'components';
import { buildCssProps } from 'utils';
import { Color } from '@bb/elements-web-rebranding';

export const StyledSubHeader = styled.div<{ $md: boolean }>`
  width: 100%;
  background-color: white;
  padding: 15px 25px;
  display: grid;
  grid-template-columns: 1fr ${({ $md }) => $md && `auto`};
  justify-content: space-between;
  grid-column-gap: 15px;
`;

export const StyledSteps = styled(Steps)<{
  $hasSupraRebrandingFeature?: boolean;
}>`
  max-width: 600px;
  ${({ $hasSupraRebrandingFeature }) =>
    $hasSupraRebrandingFeature &&
    `.ant-steps-item-active .ant-steps-item-icon {
    background: ${Color.PRIMARY};`}
}
 
`;

export const StyledTabs = styled(Tabs)`
  .ant-tabs-nav {
    background-color: white;
    padding: 0 25px;
  }
`;

export const StyledPaneTitle = styled(Text)<{ $active: boolean }>`
  width: 100px;
  text-align: center;
  color: ${({ $active }) =>
    $active ? theme.getColor('textPrimary') : theme.getColor('textSecondary')};
`;

export const StyledForm = styled.div`
  display: grid;
  grid-row-gap: 25px;
`;

export const StyledFooter = styled.div`
  height: 100%;
  background-color: white;
  width: 100%;
  position: relative;
  > div {
    display: grid;
    grid-auto-flow: column;
    justify-content: center;
    align-items: center;
    grid-column-gap: 15px;
    height: 100%;
    ${Button} {
      width: 180px;
    }
  }
  &:after {
    content: '';
    position: absolute;
    bottom: 100%;
    left: 0;
    width: 100%;
    height: 50px;
    pointer-events: none;
    box-shadow: inset 0px -15px 15px -12px rgba(0, 0, 0, 0.1);
  }
`;

export const StyledBlurOverlay = styled.div<{ $blur?: boolean }>`
  ${({ $blur }) =>
    buildCssProps([
      ['filter', $blur && `blur(${theme.pageBlurRadius})`],
      ['pointer-events', $blur && 'none'],
    ])}
`;
